import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 100%;
`

export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const HeaderText = styled.h2`
  margin: 0 0 16px 0;
  color: #333;
  font-size: 18px;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Label = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 14px;
`

export const Input = styled.input`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: #0091d4;
  }
`

export const ButtonCreate = styled.button`
  padding: 12px 24px;
  background: #0091d4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 16px;
  &:hover {
    background: #007bb3;
  }
`